import React from "react";
import PropTypes from "prop-types";
import { Form, Spinner } from "react-bootstrap";
 
const FormSelect = ({
  label,
  name,
  value,
  onChange,
  options,
  isInvalid,
  feedback,
  labelRequired,
  className,
  loading,
  autoComplete = "off",
  isDisabled = false,
}) => {

  return (
    <>
      <Form.Label>
        {label}
        {labelRequired && <span className="text-danger"> *</span>}
      </Form.Label>
 
      {/* If loading, show a spinner outside the select */}
      {loading ? (
        <div className="spinner-container">
          <Spinner
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="mr-2"
          />
          Loading...
        </div>
      ) : (
        <Form.Select
          name={name}
          value={value}
          onChange={onChange}
          isInvalid={isInvalid}
          className={`border-radius ${className} select-dropdown`}
          disabled={loading || isDisabled}
          autoComplete={autoComplete}
        >
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      )}
 
      {isInvalid && (
        <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
      )}
    </>
  );
};
 
FormSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  isInvalid: PropTypes.bool,
  feedback: PropTypes.string,
  labelRequired: PropTypes.bool,
  loading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
 
export default FormSelect;
 
 